var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "detail_day", attrs: { id: _vm.id } }, [
    _c("div", { staticClass: "inner_schedule" }, [
      _c("div", { staticClass: "info_schedule" }, [
        _c("span", { staticClass: "time_schedule" }, [
          _c("span", { staticClass: "sr_only" }, [_vm._v("시작시간")]),
          _vm._v(" "),
          _c("span", {
            staticClass: "inner_time",
            domProps: { innerHTML: _vm._s(_vm.iconText) }
          })
        ]),
        _vm._v(" "),
        _c("strong", { staticClass: "tit_schedule" }, [
          _vm._v(_vm._s(_vm.schedule.title))
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "remark_schedule" }, [
          _c("span", { staticClass: "color_remark", style: _vm.style }),
          _vm._v("\n\t\t\t\t" + _vm._s(_vm.schedule.category.name) + "\n\t\t\t")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info_schedule" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("span", { domProps: { innerHTML: _vm._s(_vm.formattedKoreanTime) } })
      ]),
      _vm._v(" "),
      _vm.schedule.timeZone && _vm.schedule.timeZone.timezoneId !== 1
        ? _c("div", { staticClass: "info_schedule" }, [
            _vm._m(1),
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.schedule.timeZone.name) +
                " (GMT" +
                _vm._s(_vm.gmt) +
                ") 기준"
            ),
            _c("br"),
            _vm._v("현지시간 " + _vm._s(_vm.formattedLocalTime) + "\n\t\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.schedule.description || _vm.schedule.image
        ? _c("div", { staticClass: "info_schedule" }, [
            _vm._m(2),
            _vm._v(" "),
            _vm.schedule.description
              ? _c("p", {
                  staticClass: "info_description",
                  domProps: { innerHTML: _vm._s(_vm.description) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.schedule.image
              ? _c(
                  "a",
                  {
                    staticClass: "thumb_link",
                    attrs: {
                      href: _vm.escapeScheduleImageThumbUrl(_vm.schedule.image),
                      target: "_blank"
                    }
                  },
                  [_c("span", { staticClass: "thumb_g", style: _vm.bgImage })]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.schedule.location
        ? _c("div", { staticClass: "info_schedule" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link_location",
                attrs: {
                  href:
                    "//map.daum.net/?from=total&nil_suggest=btn&tab=place&q=" +
                    _vm.schedule.location,
                  target: "_blank"
                }
              },
              [_vm._v(_vm._s(_vm.schedule.location))]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.isAdmin
      ? _c("div", { staticClass: "wrap_btn wrap_btn_type2" }, [
          _c(
            "button",
            {
              staticClass: "btn_comm btn_delete",
              attrs: { type: "button" },
              on: { click: _vm.deleteSchedule }
            },
            [
              _c("span", { staticClass: "ico_cafe ico_delete" }, [
                _vm._v("삭제")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("삭제하기")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn_comm btn_modify",
              attrs: { type: "button" },
              on: { click: _vm.modifySchedule }
            },
            [
              _c("span", { staticClass: "ico_cafe ico_modify" }, [
                _vm._v("수정")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("수정하기")])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "info_ico" }, [
      _c("span", { staticClass: "ico_cafe ico_time" }, [_vm._v("시간")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "info_ico" }, [
      _c("span", { staticClass: "ico_cafe ico_global" }, [
        _vm._v("해외기준시간")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "info_ico" }, [
      _c("span", { staticClass: "ico_cafe ico_memo" }, [_vm._v("메모")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "info_ico" }, [
      _c("span", { staticClass: "ico_cafe ico_location" }, [_vm._v("위치")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }